import { type TValidationConfig } from '../types/configs';

import { getDateValidation, getNumberValidation, getObjectValidation, getStringValidation } from './validations';

function getHeaderSchema(validationConfig: TValidationConfig) {
  return {
    licenseType: getObjectValidation({ field: 'licenseType' }),
    userReferenceNumber: getStringValidation({ field: 'userReferenceNumber', validationConfig }),
    requestNumber: getStringValidation({ field: 'requestNumber', validationConfig }),
    requestDate: getDateValidation({ field: 'requestDate', validationConfig }),
    extendTo: getDateValidation({ field: 'extendTo', validationConfig }),
    approvalReference: getStringValidation({ field: 'approvalReference', validationConfig }),
    approvalDate: getDateValidation({ field: 'approvalDate', validationConfig }),
    approvalFrom: getDateValidation({ field: 'approvalFrom', validationConfig }),
    approvalTo: getDateValidation({ field: 'approvalTo', validationConfig }),
    countryOfDestinationCode: getObjectValidation({ field: 'countryOfDestinationCode' }),
    departmentOfficeCode: getObjectValidation({ field: 'departmentOfficeCode' }),
    typeOfUse: getObjectValidation({ field: 'typeOfUse' }),
    placeOfLoadingCode: getObjectValidation({ field: 'placeOfLoadingCode' }),
    placeOfUnloadingCode: getObjectValidation({ field: 'placeOfUnloadingCode' }),
    termsOfDeliveryCode: getObjectValidation({ field: 'termsOfDeliveryCode' }),
    invoiceCurrencyCode: getObjectValidation({ field: 'invoiceCurrencyCode' }),
    customsOfficeCode: getObjectValidation({ field: 'customsOfficeCode' }),
    invoiceAmountInForeignCurrency: getNumberValidation({
      field: 'invoiceAmountInForeignCurrency',
      min: 0,
      validationConfig,
    }),
    invoiceAmountInNationalCurrency: getNumberValidation({
      field: 'invoiceAmountInNationalCurrency',
      min: 0,
      validationConfig,
    }),
  };
}

export default getHeaderSchema;
